import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import { Fade } from 'transitions-kit';
import type { Flag } from '../../types';
import css from './flag.module.scss';
import { Select } from './select';
import { Switch } from './switch';
import { useFlag } from './use-flag';
interface Props {
  flag: Flag;
}
export function FeatureFlag(t0) {
  const $ = _c(23);
  const {
    flag
  } = t0;
  const {
    value,
    isOverride,
    link
  } = useFlag(flag);
  const Control = typeof value === "boolean" ? Switch : Select;
  let t1;
  if ($[0] !== flag.key || $[1] !== link) {
    t1 = <a target="_blank" className={css.name} href={link}>{flag.key}</a>;
    $[0] = flag.key;
    $[1] = link;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== flag.isAbTest) {
    t2 = cn(css.tag, {
      [css.ab]: flag.isAbTest
    });
    $[3] = flag.isAbTest;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = flag.isAbTest ? "\u2726 A/B Test" : "\u2756 Targeted Delivery";
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className={cn(css.tag, css.override)}>∅ override</span>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isOverride) {
    t6 = <Fade in={isOverride}>{t5}</Fade>;
    $[9] = isOverride;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t6) {
    t7 = <div className={css.tags}>{t4}{t6}</div>;
    $[11] = t4;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t1 || $[15] !== t7) {
    t8 = <div>{t1}{t7}</div>;
    $[14] = t1;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== Control || $[18] !== flag) {
    t9 = <Control flag={flag} />;
    $[17] = Control;
    $[18] = flag;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div className={css.flag}>{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}